import { Field, RadioGroup, TextOutput } from 'Components/Core';
import { NamePrefixModifier, withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { FieldSet, ListFieldSection, PageSection } from 'Components/Layout';
import { toMessageProps } from 'Components/Worksheets/Core/Helpers/messageHelpers';
import { IWorksheetComponent } from 'Components/Worksheets/Core/types';
import { ManageSeparationsButton } from 'Components/Worksheets/PsdSieveAnalysisWorksheet/Components';
import { SieveAdditionFieldSet } from 'Components/Worksheets/PsdSieveAnalysisWorksheet/Components/SieveAdditionFieldSet';
import { getSeparationSieveSizeIds } from 'Components/Worksheets/PsdSieveAnalysisWorksheet/Helpers';
import { ISieveSize, SieveSizeId, getById } from 'Data/ViewModels/Equipment/ISieveSize';
import { Message } from 'Data/ViewModels/IApiDataModel';
import { combine, pipe } from 'Lib/Hooks/Selectors';
import deepEquals from 'Lib/Object/deepEquals';
import React from 'react';
import { useSelector } from 'react-redux';

let TestPreparationPageSection: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }) => {
  const separatingSievesList = useSelector(
    combine(
      [
        pipe(createWorksheetSelector!('', false), getSeparationSieveSizeIds),
        createWorksheetSelector!('Equipment.AllSieveSizes'),
      ],
      (ids: SieveSizeId[], allSieves: ISieveSize[]) =>
        ids.length > 0 ? ids.map((id: SieveSizeId) => getById(allSieves, id)?.Caption ?? 'Not set').join(', ') : 'None'
    )
  );

  const cumulativeOptions = [
    { label: 'Cumulative', value: true },
    { label: 'Individual', value: false },
  ];

  const separatingSievesMessages = useSelector(
    pipe(
      createWorksheetSelector!('Preparation.Messages'),
      (m) => (m as Array<Message>)?.filter((m) => ['SeparatingSievesList'].includes(m.PropertyName)),
      (m) => m.map(toMessageProps)
    ),
    deepEquals
  );

  return (
    <PageSection heading="Test Preparation">
      <NamePrefixModifier appendNamePrefix="Preparation">
        <ListFieldSection>
          <Field input={<RadioGroup />} name="AreSieveMassesCumulative" options={cumulativeOptions} />
          <SieveAdditionFieldSet />
          <FieldSet>
            <Field
              input={<TextOutput />}
              label="Separating Sieve(s)"
              value={separatingSievesList}
              messages={separatingSievesMessages}
            />
            <div>
              <ManageSeparationsButton maxSeparations={3} defaultSieveSizes={['4_75', '0_600']} />
            </div>
          </FieldSet>
        </ListFieldSection>
      </NamePrefixModifier>
    </PageSection>
  );
};

TestPreparationPageSection = withInjectedProps(TestPreparationPageSection);

export { TestPreparationPageSection };
export default TestPreparationPageSection;
